const hijackTargets = document.querySelectorAll('.hijack-content-wrap');
const hijackActiveClass = 'hijack-active';
const intersectionHijack = (target) => {
	const io = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const activeKey = Number(entry.target.getAttribute('data-hijack-key'));
					const hijackWrappers = document.querySelectorAll('[data-hijack-key]');
					hijackWrappers.forEach((wrap) => {
						const curKey = Number(wrap.getAttribute('data-hijack-key'));
						if (curKey === activeKey) {
							wrap.classList.add(hijackActiveClass);
						} else {
							wrap.classList.remove(hijackActiveClass);
						}
					});
				}
			});
		},
		{ threshold: [1] }
	);
	io.observe(target);
};
hijackTargets.forEach(intersectionHijack);
